<template>
  <wrld-container>
    <v-container class="bg fill-height text-center">
      <v-row align="center">
        <v-col>
          <h1>
                {{$t('dashboard.welcome')}}
              </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="foo">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                large
                dark
                color="dark"
                v-on="on"
                @click="changeRoute('OrganizationsOverview')"
              >
                <v-icon>business</v-icon>
              </v-btn>
            </template>
            <span>{{$t('menu.organizations')}}</span>
          </v-tooltip>
        </v-col>
        <v-col class="foo">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                large
                dark
                color="dark"
                v-on="on"
                @click="changeRoute('OrdersOverview')"
                width="72"
                height="72"
              >
                <v-icon>fas fa-archive</v-icon>
              </v-btn>
            </template>
            <span>{{$t('menu.orders')}}</span>
          </v-tooltip>
        </v-col>

        <v-col class="foo">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                large
                dark
                color="dark"
                v-on="on"
                @click="changeRoute('Shipments')"
              >
                <v-icon>place</v-icon>
              </v-btn>
            </template>
            <span>{{$t('menu.shipments')}}</span>
          </v-tooltip>
        </v-col>

        <v-col class="foo">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                large
                dark
                color="dark"
                v-on="on"
                @click="changeRoute('ShipmentsReport')"
                width="72"
                height="72"
              >
                <v-icon>poll</v-icon>
              </v-btn>
            </template>
            <span>{{$tc('menu.reports', 2)}}</span>
          </v-tooltip>
        </v-col>
      </v-row>



      <!-- <v-row>
        <v-col>
          <v-row align="center">
            <v-col>
              <h1>
                {{$t('dashboard.welcome')}}
              </h1>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="foo">
          <v-row>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    large
                    dark
                    color="dark"
                    v-on="on"
                    @click="changeRoute('OrganizationsOverview')"
                  >
                    <v-icon>business</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('menu.organizations')}}</span>
              </v-tooltip>
        </v-col>
        <v-col>
          <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    large
                    dark
                    color="dark"
                    v-on="on"
                    @click="changeRoute('Orders')"
                    width="72"
                    height="72"
                  >
                    <v-icon>fas fa-archive</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('menu.orders')}}</span>
              </v-tooltip>
        </v-col>
        <v-col>
          <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    large
                    dark
                    color="dark"
                    v-on="on"
                    @click="changeRoute('ShipmentsOverview')"
                  >
                    <v-icon>place</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('menu.shipments')}}</span>
              </v-tooltip>
        </v-col>
        <v-col>
          <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    large
                    dark
                    color="dark"
                    v-on="on"
                    @click="changeRoute('Reports')"
                    width="72"
                    height="72"
                  >
                    <v-icon>poll</v-icon>
                  </v-btn>
                </template>
                <span>{{$tc('menu.reports', 2)}}</span>
              </v-tooltip>
        </v-col>
      </v-row> -->
    </v-container>
  </wrld-container>
</template>

<script>
import router from '../router'

export default {
  name: 'Dashboard',
  data () {
    return {
      center: {
        lat: 48.853,
        lng: 2.298
      },
      path: [
        {
          lat: 48.853,
          lng: 2.298
        },
        {
          lat: 48.8735,
          lng: 2.2951
        }
      ],
      options: {
      },
      userPosition: null,
      zoom: 12
    }
  },
  methods: {
    changeRoute (href) {
      // this.nav = idx

      router.push({ name: href })
    }
  }
}
</script>

<style>
.foo {
  margin-top: 200px;
}
h1 {
  font-size: 28px;
}
</style>
